import { Component, Input, OnInit } from '@angular/core';
import { PropertyData } from '../../../../models';
import { BaseAddOnComponent } from '../base-addon.component';
import { GridApi, GridReadyEvent, RowNode, SelectionChangedEvent } from 'ag-grid-community';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-elearning-chapters',
  templateUrl: './elearning-chapters.component.html',
  styleUrls: ['./elearning-chapters.component.css']
})

export class ElearningChaptersComponent extends BaseAddOnComponent implements OnInit {

  private get elCycleJoin(): string {
    return `left join tDOLien L3 on L3.Fils_LIE = L1.Fils_LIE and L3.IddorLIE = (select ident from tDORelation where Code_DOR = 'REL_BO_CYCLEEL_BO_CHAPITRE')
left join tDOCycleEL cyc on cyc.Ident = L3.Pere_LIE`;
  }
  private elCycle: string = '';

  private get TypeModuleJoin(): string {
    return `left join tdolien L2 on L2.Pere_LIE = L1.Fils_LIE and L2.IddorLIE = (select ident from tDORelation where Code_DOR = 'REL_BO_CHAPITRE_BO_CONNAISSANCE')
left join tdoconnaissance conn on conn.Ident = L2.Fils_LIE
left join tBOValue val on val.VastrBOV = Type_CON and val.IdbopBOV = 'TYPLECEL'`;
  }

  public GridApi: GridApi;

  private TypeModule: string = '';

  public completeJoin: string = '';
  public completeWhere: string = '';

  public noElearning: boolean = false;

  public loadGrid: boolean = false;
  public lstIdents: string[];
  // #region DIRECTIVES
  // tslint:disable-next-line:no-input-rename
 
  @Input('input') input: PropertyData;
  //@Output('inputChange') emitter: EventEmitter<PropertyData> = new EventEmitter<PropertyData>();

  // #region CONSTRUCTEUR
  constructor(
    private modalService: NgbModal
  ) { super(); }
  // #endregion

  ngOnInit(): void {
  }

  public OnElCycleChange(value: string): void {
    this.elCycle = value;
    this.ReloadGrid();
  }
  public TypeModuleChange(value: string): void {
    this.TypeModule = value;
    this.ReloadGrid();
  }
  public ReloadGrid(): void {
    this.loadGrid = false;
    this.completeJoin = '';
    this.completeWhere = '';
    if (this.elCycle) {
      this.completeJoin = this.elCycleJoin;
      this.completeWhere = `cyc.Ident = ${this.elCycle}`;
    }
    if (this.TypeModule) {
      this.completeJoin += ' ' + this.TypeModuleJoin;
      this.completeWhere = !this.completeWhere ? this.completeWhere : `${this.completeWhere} AND`;
      if (this.TypeModule === 'EL') { this.completeWhere += ` (`; }
      this.completeWhere += ` conn.Type_CON = '${this.TypeModule}'`;
      if (this.TypeModule === 'EL') {
        this.completeWhere += ` OR conn.Type_CON is null)`;
      }
    }
    setTimeout(() => { this.loadGrid = true }, 0);
  }

  public OnSelectChange(event: SelectionChangedEvent): void {
    this.GridApi = event.api;
    this.lstIdents = event.api.getSelectedRows().map(el => `${el['Ident']}`);
  }

  public AffectValue(): void {
    this.input.MainElementList[0].Value = this.noElearning ? 'NO ELEARNING' : this.lstIdents.join(',');
  }

  public ClearList(): void {
    this.lstIdents = [];
  }

  public OnGridReady(event: GridReadyEvent): void {
    this.GridApi = event.api;
    event.api.forEachNode(node => this.lstIdents && this.lstIdents.includes(`${node.data['Ident']}`) ? node.setSelected(true) : node.setSelected(false));
  }


  public OpenModal(content: any) {
    if (this.input && this.input.MainElementList && this.input.MainElementList.length > 0 && this.input.MainElementList[0].Value)
      this.lstIdents = this.input.MainElementList[0].Value.split(',');
    else
      this.lstIdents = [];
    this.modalService.open(content, { size: 'xl', centered: true, windowClass: 'qmodalover modal-elearning-chapters-modalBoElearningChapter' }).result.then((result) => {
      switch (result) {
        //  case 'SAVE': this.saveConfigSignature(); break;
        //  case 'CANCEL': this.closeConfigSignature(); break;
      }
    });
  }
}
